export default {
  programming: {
    languages: {
      good: ['TypeScript', 'Go', 'C / C++'],
      ok: ['Rust', 'Python'],
    },
    space: [4],
    list: [
      'Conocimiento práctico de los lenguajes <b>Go</b>, <b>Rust</b> y <b>C/C++</b> en programación general, de aplicaciones, orientada a objetos, de red y <b>embebida</b>.',
      'Integración de <b>IA</b> con otras capas de la aplicación. Conocimiento práctico de los campos de <b>aprendizaje automático</b> y <b>aprendizaje profundo</b>.',
      'Programación de aplicaciones de escritorio y web utilizando tecnología <b>Vue</b> y <b>TypeScript</b>.',
      'Gestión de bases de datos: experiencia con <b>SQLite</b>, <b>MongoDB</b> y <b>MySQL</b>. Conceptos básicos de DevOps, incluido <b>Google Cloud</b>.',
      'Capacidad para <b>modelar procesos físicos</b> y ejecutar <b>simulaciones por computadora</b>, incluido el uso de <b>ML</b>.',
      'Conocimiento de métodos de ingeniería de materiales computacionales como <b>Monte Carlo</b>, <b>dinámica molecular</b> o <b>DFT</b>.',
    ],
  },
  technical: {
    space: [3, 6],
    list: [
      'Conocimiento de <b>sistemas operativos</b> y <b>arquitectura de computadoras</b>. Trabajo en sistemas <b>Linux / UNIX</b>, incluido el dominio de la <b>consola (shell)</b>.',
      'Conocimiento básico de <b>teleinformática</b>, en áreas como redes informáticas y seguridad de datos.',
      'Conocimiento práctico en el campo de las <b>telecomunicaciones</b>. Configuración de instalaciones y creación de sistemas de internet.',
      'Operación de equipos informáticos y de medición. <b>Informatización de mediciones</b> en el lenguaje <b>LabVIEW</b>.',
      'Diagnóstico y reparación de <b>dispositivos electrónicos</b>. Capacidad para leer <b>esquemas electrónicos</b>.',
      'Conceptos básicos de operación y programación de microcontroladores <b>AVR</b> y sistemas integrados, específicamente <b>Arduino</b>.',
      'Capacidad para crear y leer <b>dibujos técnicos</b> y crear esquemas 2D y 3D en el programa <b>NX</b>.',
      'Experiencia en métodos avanzados de investigación de materiales como: <b>XRD, DSC, DTA / TGA, TMA, XAS</b>, así como <b>espectroscopía</b>: de absorción, luminiscencia, impedancia o infrarroja.',
    ],
  },
  science: {
    space: [5],
    list: [
      'Conocimiento integral de procesos y tecnologías utilizadas en la <b>física y química de materiales avanzados</b>.',
      'Experiencia en la <b>física de procesos iónicos</b>, particularmente en tecnologías de <b>procesamiento y almacenamiento</b> de energía.',
      'Conocimiento de aplicaciones modernas de la <b>física de estructuras de semiconductores</b> y la <b>electrónica de estado sólido</b>.',
      'Conocimiento práctico de la teoría y los procesos tecnológicos en la producción de <b>nanoestructuras</b> y <b>sistemas de baja dimensión</b>.',
      'Conocimiento práctico y resolución de problemas en los campos de <b>física láser</b>, <b>optoelectrónica y fotónica</b>, y aplicaciones de la <b>física nuclear</b>.',
      'Conocimiento de elementos de <b>matemáticas superiores</b> avanzadas en <b>aplicaciones de ingeniería y programación</b>.',
      'Conocimiento básico de <b>estadística y análisis de datos</b> en <b>ROOT</b> y <b>Python</b>. Trabajo con bibliotecas <b>NumPy</b>, <b>Pandas</b> y <b>Matplotlib</b>.',
      'Capacidad básica para realizar cálculos <b>numéricos</b> y simbólicos en <b>Mathematica</b> y <b>Python</b>.',
    ],
  },
  soft: {
    list: [
      'Facilidad para <b>adquirir conocimientos</b>. <b>Aprendizaje</b> rápido, <b>flexibilidad</b> y <b>adaptación</b> a los cambios.',
      'Capacidad en <b>gestión de proyectos</b> y <b>trabajo en equipo</b>. Experiencia como líder y miembro de equipo.',
      'Buenas <b>habilidades de comunicación</b> y organización. <b>Apertura en el trato</b> con las personas.',
      'Experiencia en comunicación especializada en <b>inglés</b> confirmada por la participación en conferencias científicas.',
      'Capacidad para el <b>pensamiento lógico, creativo y crítico</b>.',
    ],
  },
}
